import { useEffect } from 'react'
import { Auth0Provider, withAuthenticationRequired } from '@auth0/auth0-react'
import { Router, Redirect, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { QueryParamProvider } from 'use-query-params'

import config from './config'
import AuthTest from './pages/AuthTest'
import Downloader from './pages/Downloader'
import Portal from './pages/Portal'
// import TtmPage from './pages/TtmPage'
import Uploader from './pages/Uploader'

// automatically redirect user to Auth0 login page when they try to access this route
const ProtectedAuthTest = withAuthenticationRequired(AuthTest, {
  // display loading message while loading auth or redirecting user
  onRedirecting: () => <div>Loading...</div>,
})

// dynamically adds a title, passed in through props, to the current page
const RouteWithTitle = ({ title = '', ...props }) => {
  useEffect(() => {
    document.title = title
  }, [title])
  return <Route {...props} />
}

function App() {
  const history = createBrowserHistory()
  const handleRedirect = (appState) => {
    // redirects the user to the proper route after login.
    // this custom callback is needed because we are using React-Router.
    history.push(
      appState && appState.returnTo
        ? appState.returnTo
        : window.location.pathname
    )
  }

  return (
    <Auth0Provider
      {...config.auth0}
      redirectUri={`${window.location.origin}/navigator`}
      onRedirectCallback={handleRedirect}
      cacheLocation={'localstorage'}
      useRefreshTokens={true}
    >
      <Router history={history}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <RouteWithTitle
              exact
              path="/"
              component={Portal}
              title="Awa Model Manager"
            />
            <RouteWithTitle
              path="/download"
              component={Downloader}
              title="Awa Model Downloader"
            />
            <RouteWithTitle
              path="/upload"
              component={Uploader}
              title="Awa Model Uploader"
            />
            {config.authEnabled ? (
              <RouteWithTitle
                path="/auth-test"
                component={AuthTest}
                title="Authorization Test"
              />
            ) : null}
            {config.authEnabled ? (
              <RouteWithTitle
                path="/auth-test-require-login"
                component={ProtectedAuthTest}
                title="Authorization Test (Login Required)"
              />
            ) : null}
            <Route
              path="/navigator/:project?"
              render={({ match: { params: { project } } }) => {
                window.location.href = `${config.dataNavigatorUrl}/${project ? project + "/" : ""}models`
                return null
              }}
            />
            <Redirect to="/" />
          </Switch>
        </QueryParamProvider>
      </Router>
    </Auth0Provider>
  )
}

export default App
